import { ScrollingModule } from "@angular/cdk/scrolling";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NgInterswitchModule } from '@interswitchapi/ng-interswitch';
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxPrintModule } from 'ngx-print';
import { NgxSpinnerModule } from "ngx-spinner";
import { environment } from "../environments/environment";
import { AccomodationComponent } from './accomodation/accomodation.component';
import { AddResourceQuestionComponent } from './add-resource-question/add-resource-question.component';
import { AddResponseComponent } from './add-response/add-response.component';
import { AddnoteDialogComponent } from './addnote-dialog/addnote-dialog.component';
import { AnnouncementBottomsheetComponent } from './announcement-bottomsheet/announcement-bottomsheet.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from "./app.component";
import { AuthGuard } from "./auth.guard";
import { CbtComponent } from "./cbt/cbt.component";
import { CBTLayoutComponent } from "./cbtlayout/cbtlayout.component";
import { ChangePasscodeComponent } from "./change-passcode/change-passcode.component";
import { ComponentsModule } from "./components/components.module";
import { ConfirmSnackbarComponent } from "./confirm-snackbar/confirm-snackbar.component";
import { ConfirmComponent } from "./confirm/confirm.component";
import { CourseRegistrationComponent } from "./course-registration/course-registration.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DesktopAnnouncementComponent } from './desktop-announcement/desktop-announcement.component';
import { DesktopResourcesNoteComponent } from './desktop-resources-note/desktop-resources-note.component';
import { DesktopResourcesQuestionsComponent } from './desktop-resources-questions/desktop-resources-questions.component';
import { DesktopSubResourcesComponent } from './desktop-sub-resources/desktop-sub-resources.component';
import { DocumentImageComponent } from "./document-image/document-image.component";
import { DocumentListComponent } from "./document-list/document-list.component";
import { DocumentsComponent } from "./documents/documents.component";
import { ElectionComponent } from "./election/election.component";
import { ExamDetailsComponent } from "./exam-details/exam-details.component";
import { ExamScoreSummaryComponent } from "./exam-score-summary/exam-score-summary.component";
import { SearchFilterPipe } from "./filter-pipe";
import { FilterPipe } from "./filter.pipe";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { HelpComponent } from "./help/help.component";
import { HomeLayoutComponent } from "./home-layout/home-layout.component";
import { CredentialsInterceptor } from "./interceptors/credentials.interceptors";
import { LoginLayoutComponent } from "./login-layout/login-layout.component";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./logout/logout.component";
import { Material } from "./material.module";
import { MessagesComponent } from "./messages/messages.component";
import { MyProfileComponent } from "./my-profile/my-profile.component";
import { NoticeBoardComponent } from './notice-board/notice-board.component';
import { NoticeFilterPipe } from './notice-filter.pipe';
import { NotificationsComponent } from "./notifications/notifications.component";
import { OtherPaymentsComponent } from "./other-payments/other-payments.component";
import { PayTuitionComponent } from "./pay-tuition/pay-tuition.component";
import { PaymentDialogComponent } from './payment-dialog/payment-dialog.component';
import { PaymentHistoryComponent } from "./payment-history/payment-history.component";
import { PayperbyteWarnDialogComponent } from "./payperbyte-warn-dialog/payperbyte-warn-dialog.component";
import { SafePipe } from './pipes/safe.pipe';
import { RegisterNewCourseComponent } from "./register-new-course/register-new-course.component";
import { RegistrationHistoryComponent } from "./registration-history/registration-history.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { ResourcesNoteComponent } from './resources-note/resources-note.component';
import { ResourcesQuestionAnswerComponent } from './resources-question-answer/resources-question-answer.component';
import { ResourcesPipe } from "./resources.pipe";
import { ResourcesComponent } from "./resources/resources.component";
import { SemesterResultComponent } from "./semester-result/semester-result.component";
import { AuthService } from "./services/auth.service";
import { CompanyDetailsService } from "./services/company-details.service";
import { CourseAllocationService } from "./services/course-allocation.service";
import { CourseCatalogueService } from "./services/course-catalogue.service";
import { DepartmentsService } from "./services/departments.service";
import { DocumentsService } from "./services/documents.service";
import { FirebaseServerService } from './services/firebase-server.service';
import { PaymentService } from "./services/payment.service";
import { ProfileService } from "./services/profile.service";
import { ResultService } from "./services/result.service";
import { UserService } from "./services/user.service";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { StaffEvaluationComponent } from "./staff-evaluation/staff-evaluation.component";
import { StudentCertificateComponent } from './student-certificate/student-certificate.component';
import { SubResourcesBottomsheetComponent } from './sub-resources-bottomsheet/sub-resources-bottomsheet.component';
import { TermReportSheetsComponent } from "./term-report-sheets/term-report-sheets.component";
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { VideoResourceComponent } from "./video-resource/video-resource.component";
import { ViewTimetableComponent } from "./view-timetable/view-timetable.component";
import { MultiRoomComponent } from './virtual-class/multi-room/multi-room.component';
import { UserfeedbackComponent } from './virtual-class/userfeedback/userfeedback.component';
import { VideoSectionComponent } from './virtual-class/video-section/video-section.component';
import { VirtualmeetingdialogueComponent } from './virtualmeetingdialogue/virtualmeetingdialogue.component';
import { WatchResourceComponent } from "./watch-resource/watch-resource.component";
import { WeightedReportSheetsComponent } from "./weighted-report-sheets/weighted-report-sheets.component";

@NgModule({
  declarations: [
    AppComponent,
    // ToolbarComponent,
    SidenavComponent,
    DashboardComponent,
    MyProfileComponent,
    ChangePasscodeComponent,
    DocumentsComponent,
    PayTuitionComponent,
    OtherPaymentsComponent,
    PaymentHistoryComponent,
    SemesterResultComponent,
    CourseRegistrationComponent,
    RegistrationHistoryComponent,
    ViewTimetableComponent,
    FilterPipe,
    DocumentsComponent,
    DocumentListComponent,
    DocumentImageComponent,
    LoginComponent,
    LoginLayoutComponent,
    HomeLayoutComponent,
    SearchFilterPipe,
    LogoutComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    StaffEvaluationComponent,
    NotificationsComponent,
    HelpComponent,
    MessagesComponent,
    ConfirmSnackbarComponent,
    RegisterNewCourseComponent,
    CBTLayoutComponent,
    CbtComponent,
    ExamScoreSummaryComponent,
    ExamDetailsComponent,
    ConfirmComponent,
    ResourcesComponent,
    PayperbyteWarnDialogComponent,
    ResourcesPipe,
    ElectionComponent,
    VideoResourceComponent,
    WatchResourceComponent,
    SafePipe,
    ResourcesNoteComponent,
    AddnoteDialogComponent,
    ResourcesQuestionAnswerComponent,
    AddResourceQuestionComponent,
    AddResponseComponent,
    DesktopResourcesNoteComponent,
    DesktopResourcesQuestionsComponent,
    SubResourcesBottomsheetComponent,
    DesktopSubResourcesComponent,
    AnnouncementBottomsheetComponent,
    DesktopAnnouncementComponent,
    NoticeBoardComponent,
    NoticeFilterPipe,
    TransactionHistoryComponent,
    AccomodationComponent,
    VideoSectionComponent,
    PaymentDialogComponent,
    MultiRoomComponent,
    UserfeedbackComponent,
    StudentCertificateComponent,
    VirtualmeetingdialogueComponent,
    StudentCertificateComponent,
    TermReportSheetsComponent,
    WeightedReportSheetsComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    Material,
    MatDialogModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule,
    HttpClientModule,
    // SnotifyModule, 
    MatBottomSheetModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),

    NgxSpinnerModule,
    ComponentsModule,
    NgSelectModule,
    NgxPrintModule,
    NgInterswitchModule,
  ],
  providers: [
    CompanyDetailsService,
    ProfileService,
    PaymentService,
    DocumentsService,
    ResultService,
    UserService,
    DepartmentsService,
    CourseAllocationService,
    CourseCatalogueService,
    AuthService,
    AuthGuard,
    FirebaseServerService,

    // { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CredentialsInterceptor,
      multi: true,
    },
    // SnotifyService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { }

// if (ngModuleType.ɵmod.id !== null) {
//   /** @type {?} */
//   const id = ngModuleType.ɵmod.id;
//   /** @type {?} */
//   const existing = (/** @type {?} */ (modules.get(id)));
//   assertSameOrNotExisting(id, existing, ngModuleType);
//   modules.set(id, ngModuleType);
// }